<template>
  <div class="home content">
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="15">
        <div>
          <el-carousel height="400px">
            <el-carousel-item v-for="item in pictureList" :key="item.id">
              <a
                style="
                  width: 100%;
                  height: 100%;
                  background: #ddd;
                  display: block;
                "
                :href="item.url"
                target="_blank"
              >
                <img
                  :src="'/attachmentDir/' + item.attachment.filesName"
                  width="100%"
                  height="100%"
                />
                <p class="carouselItemText beyondEllipsis">
                  {{ item.carouselName }}
                </p>
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="9">
        <div class="notice box">
          <div class="move">
            <a @click="openNotice">
              更多
              <i class="el-icon-d-arrow-right"></i>
            </a>
          </div>
          <div class="title">通知公告</div>
          <div
            style="padding: 100px 0; text-align: center"
            v-if="noticeList.length == 0"
          >
            <img src="@/assets/img/kong.png" width="100px" />
            <p style="padding-top: 50px">暂无数据</p>
          </div>
          <div class="list" style="height: 333px; overflow: hidden">
            <ul>
              <li
                style="cursor: pointer"
                @click="openNoticeItem(item)"
                class="pointer"
                v-for="(item, index) in noticeList"
                :key="index"
                :class="{
                  radiusTop: index == 0,
                  radiusBottom: index == noticeList.length - 1,
                  radius: noticeList.length == 1,
                  noticeRoll: noticeRoll && index == 0,
                }"
              >
                <div
                  class="beyondEllipsis"
                  style="width: 285px"
                  :title="item.title"
                >
                  <i>●</i>
                  {{ item.title }}
                </div>
                <span style="position: absolute; right: 10px; top: 20px">{{
                  moment(item.createDate).format("MM-DD")
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="benner">
      <ul
        class="bennerList"
        ref="bennerList"
        :style="{ left: bennerListLeft + 'px' }"
      >
        <li><img src="@/assets/img/banner1.jpg" /></li>
        <li><img src="@/assets/img/banner2.jpg" /></li>
        <li><img src="@/assets/img/banner3.jpg" /></li>
        <li><img src="@/assets/img/banner4.jpg" /></li>
        <li><img src="@/assets/img/banner5.jpg" /></li>
        <li><img src="@/assets/img/banner6.jpg" /></li>
        <li><img src="@/assets/img/banner7.jpg" /></li>
        <li><img src="@/assets/img/banner1.jpg" /></li>
        <li><img src="@/assets/img/banner2.jpg" /></li>
        <li><img src="@/assets/img/banner3.jpg" /></li>
        <li><img src="@/assets/img/banner4.jpg" /></li>
        <li><img src="@/assets/img/banner5.jpg" /></li>
        <li><img src="@/assets/img/banner6.jpg" /></li>
        <li><img src="@/assets/img/banner7.jpg" /></li>
      </ul>
    </div>
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="18">
        <el-row>
          <el-col :span="12" class="newsBox">
            <div class="newHead">
              <span>最新资讯</span>
              <a @click="more(news[activeName])" class="mome">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </a>
            </div>
            <div>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                  :label="item.itemText"
                  :name="index + ''"
                  v-for="(item, index) in news"
                  :key="index"
                >
                  <div class="newList">
                    <ul>
                      <li
                        v-for="(li, i) in item.children"
                        @click="textListTxt(item, i)"
                        class="pointer"
                        :key="i"
                        :class="{
                          radiusTop: index == 0,
                          radiusBottom: index == item.children.length - 1,
                          radius: item.children.length == 1,
                        }"
                      >
                        <i>●</i>
                        <span class="beyondEllipsis topicTitle">{{
                          li.title
                        }}</span>
                        <span style="float: right">{{
                          moment(li.publishDate).format("YYYY-MM-DD")
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="12" class="newsBox" style="padding-left: 15px">
            <div class="newHead">
              <span>人才共育</span>
              <a @click="more(talent[activeName2])" class="mome">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </a>
            </div>
            <div>
              <el-tabs v-model="activeName2" @tab-click="handleClick">
                <el-tab-pane
                  :label="item.itemText"
                  :name="index + ''"
                  v-for="(item, index) in talent"
                  :key="index"
                >
                  <div class="newList">
                    <ul>
                      <li
                        @click="textListTxt(item, i)"
                        class="pointer"
                        v-for="(li, i) in item.children"
                        :key="i"
                        :class="{
                          radiusTop: index == 0,
                          radiusBottom: index == item.children.length - 1,
                          radius: item.children.length == 1,
                        }"
                      >
                        <i>●</i>
                        <span class="beyondEllipsis topicTitle">{{
                          li.title
                        }}</span>
                        <span style="float: right">{{
                          moment(li.publishDate).format("YYYY-MM-DD")
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="12" class="newsBox">
            <div class="newHead">
              <span>互动交流</span>
              <a @click="more(exchange[activeName3])" class="mome">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </a>
            </div>
            <div>
              <el-tabs v-model="activeName3" @tab-click="handleClick">
                <el-tab-pane
                  :label="item.itemText"
                  :name="index + ''"
                  v-for="(item, index) in exchange"
                  :key="index"
                >
                  <div class="newList">
                    <ul>
                      <li
                        @click="textListTxt(item, i)"
                        class="pointer"
                        v-for="(li, i) in item.children"
                        :key="i"
                        :class="{
                          radiusTop: index == 0,
                          radiusBottom: index == item.children.length - 1,
                          radius: item.children.length == 1,
                        }"
                      >
                        <i>●</i>
                        <span class="beyondEllipsis topicTitle">{{
                          li.title
                        }}</span>
                        <span style="float: right">{{
                          moment(li.publishDate).format("YYYY-MM-DD")
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col :span="12" class="newsBox" style="padding-left: 15px">
            <div class="newHead" style="margin-bottom: 10px">
              <span>会员风采</span>
              <a @click="titleH2Move" class="mome">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </a>
            </div>
            <div
              class="newList"
              style="
                padding-top: 14px;
                height: 304px;
                overflow: hidden;
                position: relative;
              "
              @mouseenter="enters"
              @mouseleave="leave"
            >
              <div
                style="witht: 100%; position: absolute; left: 0; top: 0"
                :style="{
                  top: left + 'px',
                }"
              >
                <div
                  v-for="(item, index) in styleList"
                  :key="index"
                  @click="styleTxt(item)"
                  style="
                    cursor: pointer;
                    margin-bottom: 20px;
                    padding-bottom: 10px;
                  "
                  :style="{
                    borderBottom:
                      index == styleList.length - 1 ? 'none' : '1px solid #ddd',
                  }"
                >
                  <div
                    style="
                      display: inline-block;
                      width: 60px;
                      height: 60px;
                      border-radius: 50%;
                      overflow: hidden;
                    "
                  >
                    <img
                      width="100%"
                      height="100%"
                      v-if="item.logoFilesName"
                      :src="
                        item.logoFilesName.indexOf('http') == 0
                          ? item.logoFilesName
                          : item.logoFilesName.indexOf('/sanxia') == 0
                          ? item.logoFilesName
                          : '/attachmentDir/' + item.logoFilesName
                      "
                      class="img"
                    />
                    <img
                      width="100%"
                      height="100%"
                      v-else
                      src="@/assets/img/xin.png"
                      class="img"
                    />
                  </div>

                  <div
                    style="
                      display: inline-block;
                      height: 60px;
                      vertical-align: top;
                      padding-left: 10px;
                      width: 330px;
                      line-height: 20px;
                      overflow: hidden;
                    "
                  >
                    <p
                      class="beyondEllipsis"
                      style="
                        margin-bottom: 2px;
                        font-size: 16px;
                        color: #1890ff;
                      "
                    >
                      {{ item.organName }}
                    </p>
                    <div
                      class="introduce beyondEllipsis2"
                      style="font-size: 14px; height: 40px"
                    >
                      {{ item.introduce }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6" class="typeButBox">
        <div class="typeBut">
          <a
            href="/sanxia/index.html?nvaTreeId=419&childTreeId=420&leafModuleCode=SYSTEM_NEWS"
            target="_Blank"
          >
            <img src="@/assets/img/but3.png" />
            <span>通知函件</span>
          </a>
        </div>
        <div class="typeBut">
          <a
            target="_Blank"
            href="/sanxia/index.html?nvaTreeId=419&childTreeId=467&leafModuleCode=EXCHANGE_ACTIVITY"
          >
            <img src="@/assets/img/but0.png" />
            <span>培训对接</span>
          </a>
        </div>
        <div class="typeBut">
          <a
            target="_Blank"
            href="/sanxia/index.html?nvaTreeId=419&childTreeId=446&leafModuleCode=EXCHANGE_RECRUITJOB"
          >
            <img src="@/assets/img/but1.png" />
            <span>就业信息</span>
          </a>
        </div>
        <div class="typeBut">
          <a target="_Blank" href="http://sxgl.sxyyc.net/">
            <img src="@/assets/img/but5.png" />
            <span>学生实习</span>
          </a>
        </div>
        <div class="typeBut">
          <a target="_Blank" href="#/questionnaire?id=-1">
            <img src="@/assets/img/but6.png" />
            <span>调查问卷</span>
          </a>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <div class="resourceBox">
          <div
            class="heades"
            style="
              margin: -10px -10px 20px -10px;
              border-bottom: 2px solid #1890ff;
            "
          >
            <img src="@/assets/img/headImg.png" />
            <span class="titles">资源推荐</span>
            <a
              class="headesMove"
              style="color: #f5a712; right: 90px"
              @click="openList"
              >常用表格</a
            >
            <a class="headesMove" @click="openList">
              更多
              <i class="el-icon-d-arrow-right"></i>
            </a>
          </div>
          <div
            style="padding: 100px 0; text-align: center"
            v-if="resource1.length == 0"
          >
            <img src="@/assets/img/kong.png" width="100px" />
            <p style="padding-top: 50px">暂无数据</p>
          </div>
          <div
            class="resource0 pointer"
            v-if="resource1[0]"
            @click="changeItem(resource1[0])"
            style="margin-bottom: 10px"
          >
            <img
              width="100px"
              height="100px"
              :src="
                resource1[0].coverPictureFiles.indexOf('http') == 0
                  ? resource1[0].coverPictureFiles
                  : resource1[0].coverPictureFiles.indexOf('/sanxia') == 0
                  ? resource1[0].coverPictureFiles
                  : '/attachmentDir/' + resource1[0].coverPictureFiles
              "
              class="img"
            />
            <div
              class="resourceTitle beyondEllipsis"
              style="color: #1890ff; font-size: 16px; font-weight: 100"
            >
              {{ resource1[0].resourceTitle }}
            </div>
            <div class="resourceContent">
              {{ resource1[0].resourceContent }}
            </div>
          </div>
          <ul>
            <li
              @click="changeItem(item)"
              v-for="(item, index) in resource1"
              :key="index"
              v-show="index != 0"
            >
              <div class="resourceTitle1 beyondEllipsis pointer">
                <i>●</i>
                {{ item.resourceTitle }}
              </div>
              <!-- <span class="createDate">{{moment(item.createDate).format('YYYY-MM-DD')}}</span> -->
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="resourceBox">
          <div
            class="heades"
            style="
              margin: -10px -10px 20px -10px;
              border-bottom: 2px solid #1890ff;
            "
          >
            <img src="@/assets/img/headImg.png" />
            <span class="titles">学习中心</span>

            <a class="headesMove" @click="openList2">
              更多
              <i class="el-icon-d-arrow-right"></i>
            </a>
          </div>
          <div
            style="padding: 100px 0; text-align: center"
            v-if="resource2.length == 0"
          >
            <img src="@/assets/img/kong.png" width="100px" />
            <p style="padding-top: 50px">暂无数据</p>
          </div>
          <div v-for="(item, index) in resource2" :key="index">
            <div @click="changeVideo(item)" class="resource0 pointer">
              <img
                width="100px"
                height="100px"
                :src="
                  item.coverPictureFiles.indexOf('http') == 0
                    ? item.coverPictureFiles
                    : item.coverPictureFiles.indexOf('/sanxia') == 0
                    ? item.coverPictureFiles
                    : '/attachmentDir/' + item.coverPictureFiles
                "
                class="img"
              />
              <div
                class="resourceTitle beyondEllipsis"
                style="color: #1890ff; font-size: 16px; font-weight: 100"
              >
                {{ item.resourceTitle }}
              </div>
              <div class="resourceContent">{{ item.resourceContent }}</div>
            </div>
            <p style="padding: 10px 0" v-if="index != resource2.length - 1">
              <el-divider></el-divider>
            </p>
          </div>

          <!-- <ul>
            <li @click="openList2" v-for="(item,index) in resource2" :key="index" v-show="index!=0">
              <div class="resourceTitle1 beyondEllipsis pointer">{{item.resourceTitle}}</div>
              <span class="createDate">{{moment(item.createDate).format('YYYY-MM-DD')}}</span>
            </li>
          </ul>-->
        </div>
      </el-col>
    </el-row>
    <login-view ref="loginView" :cancel="false" />
  </div>
</template>

<script>
import moment from "moment";
import loginView from "@/components/loginView";
import {
  menuItem_qy,
  CarouselPictureQy,
  noticeQy,
  organ_qy,
  resource_qy,
  topic_qy,
  demand_qy,
  recruit_qy,
  videoResourceQy,
  autoApi,
  login,
} from "@/api/home";
if (!window.noticeSetInt) {
  window.noticeSetInt = null;
}
if (!window.styleLeft) {
  window.styleLeft = null;
}
export default {
  components: { loginView },
  data() {
    return {
      activeName3: "0",
      activeName2: "0",
      activeName: "0",
      moment,
      activeIndex: "1",
      list: [],
      pictureList: [],
      noticeList: [],
      noticePageNo: 1,
      noticeTotalCount: 0,
      styleList: [],
      left: 0,
      bennerListLeft: 0,
      resource1: [],
      resource2: [],
      textList1: [],
      textList2: [],
      textList3: [],
      textList4: [],
      textList5: [],
      textList6: [],
      textList0: [],
      textList7: [],
      textList8: [],
      noticeRoll: false,
      noticeListRoll: [],
      news: [],
      talent: [],
      exchange: [],
      activeIndex: "",
      enter: false,
    };
  },
  created() {},
  mounted() {
    this.getPicture();
    this.getNoticeQy();
    this.getResource_qy();
    this.getStyleList();
    this.getResource_qy2();
    this.getMenuItemNEWS();
    this.getMenuItemTALENT();
    this.getMenuItemEXCHANGE();
    let vm = this;
    let left = 0;
    clearInterval(window.bennerList);
    window.bennerList = setInterval(() => {
      left -= 1;
      this.bennerListLeft = left;
      if (parseInt(vm.$refs.bennerList.clientWidth / 2) + left < 0) {
        this.bennerListLeft = 0;
        left = 0;
      }
    }, 10);
    // setTimeout((res) => {
    //   console.log(vm.$refs.bennerList.clientWidth);
    // }, 1000);
  },
  methods: {
    changeVideo(item) {
      login({ op: "getSessionUser" })
        .then((response) => {
          if (!response) {
            this.$refs.loginView.show();
          } else {
            this.changeVideo2(item);
          }
        })
        .catch((error) => {});
    },
    changeVideo2(item) {
      let routerJump;
      routerJump = this.$router.resolve({
        name: "videoPlay",
        query: {
          id: this.$route.query.id,
          url: item.attachment.filesName,
          resourceClassId: this.resourceClassId,
          name: item.resourceTitle,
          resourceId: item.resourceId,
        },
      });
      window.open(routerJump.href, "_blank");

      // this.$router.push({
      //   path: "/videoPlay",
      //   query: {
      //     id: this.$route.query.id,
      //     url: item.attachment.filesName,
      //     resourceClassId: this.resourceClassId,
      //     name: item.resourceTitle,
      //     resourceId: item.resourceId
      //   }
      // });
    },
    changeItem(item) {
      login({ op: "getSessionUser" })
        .then((response) => {
          if (!response) {
            this.$refs.loginView.show();
          } else {
            this.changeItem2(item);
          }
        })
        .catch((error) => {});
    },
    changeItem2(item) {
      if (item.resourceStyle == "1") {
        let routerJump;
        routerJump = this.$router.resolve({
          name: "titleDetailPage",
          query: {
            id: this.$route.query.id,
            url: "/erp/resource/resourceQy.json?op=getResourceByResourceId",
            pageViewId: item.resourceId,
          },
        });
        window.open(routerJump.href, "_blank");
      } else if (item.resourceStyle == "0") {
        window.open("/attachmentDir/" + item.attachment.filesName);
      } else {
        item.resourceContent = item.resourceContent || "";
        if (item.resourceContent.indexOf("www") == 0) {
          item.resourceContent = "http://" + item.resourceContent;
        }
        window.open(item.resourceContent);
      }
    },
    jump(item) {
      this.activeIndex = item.id;
      this.$forceUpdate();
      if (item.pageUrl && item.pageUrl != "-") {
        if (item.pageUrl == "/leftMenuListPage") {
          let routerJump;
          routerJump = this.$router.resolve({
            path: item.pageUrl,
            query: {
              id: item.id,
              url: item.argumentsText,
            },
          });
          window.open(routerJump.href, "_blank");
        } else if (item.pageUrl == "/parallelListPage") {
          let routerJump;
          routerJump = this.$router.resolve({
            path: item.pageUrl,
            query: {
              id: item.id,
              url: item.argumentsText,
              name: item.itemText,
            },
          });
          window.open(routerJump.href, "_blank");
        } else if (item.pageUrl.indexOf("www.") == 0) {
          window.open("http://" + item.pageUrl);
        } else if (item.pageUrl.indexOf("http") == 0) {
          window.open(item.pageUrl);
        } else {
          let routerJump;
          routerJump = this.$router.resolve({
            path: item.pageUrl,
            query: {
              id: item.id,
            },
          });
          window.open(routerJump.href, "_blank");
        }
      }
    },
    more(item) {
      this.jump(item);
    },
    textListTxt(item, i) {
      if (item.itemCode == "RECRUITJOB") {
        this.textList6Txt(item.children[i]);
        return;
      }

      let routerJump;
      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: item.argumentsText.split("\n")[2],
          pageViewId: item.children[i].pageViewId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    childrenList(url, res) {
      autoApi(url, {
        pageNo: 1,
        pageSize: 7,
      }).then((data) => {
        res.children = data.result;
        res.children.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.content;
          res.content = objE.innerText;
        });
      });
    },
    getMenuItemNEWS() {
      menuItem_qy({
        op: "findPortalMenuTree",
        parentItemCode: "NEWS",
      }).then((res) => {
        this.news = res;
        this.news.map((data) => {
          if (data.arguments && data.pageUrl == "/leftMenuListPage") {
            let url = data.argumentsText.split("\n")[1];
            this.childrenList(url, data);
          }
        });
      });
    },
    getMenuItemTALENT() {
      menuItem_qy({
        op: "findPortalMenuTree",
        parentItemCode: "TALENT",
      }).then((res) => {
        this.talent = res;
        this.talent.map((data) => {
          if (data.itemCode == "RECRUITJOB") {
            recruit_qy({ op: "findPageRecruitJob", pageSize: 7 }).then(
              (res) => {
                res.result.map((res) => {
                  res.title = res.jobName;
                });
                data.children = res.result;
              }
            );
            return;
          }
          if (data.arguments && data.pageUrl == "/leftMenuListPage") {
            let url = data.argumentsText.split("\n")[1];
            this.childrenList(url, data);
          }
        });
      });
    },
    getMenuItemEXCHANGE() {
      menuItem_qy({
        op: "findPortalMenuTree",
        parentItemCode: "EXCHANGE",
      }).then((res) => {
        this.exchange = res;
        this.exchange.map((data) => {
          if (data.arguments && data.pageUrl == "/leftMenuListPage") {
            let url = data.argumentsText.split("\n")[1];
            this.childrenList(url, data);
          }
        });
      });
    },
    handleClick() {},
    mouseover() {
      clearInterval(window.styleLeft);
    },
    mouseleave() {
      this.styleLeftSetInt();
    },
    openList2() {
      let routerJump;

      routerJump = this.$router.resolve({
        path: "/VideoList",
        query: {
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    openList() {
      let routerJump;

      routerJump = this.$router.resolve({
        path: "/resourceList",
        query: {
          id: -1,
        },
      });
      window.open(routerJump.href, "_blank");
    },
    styleTxt(item) {
      this.$router.push({
        path: "/titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getMemberByMemberId",
          pageViewId: item.id,
          id: -1,
        },
      });
    },
    titleH2Move() {
      let routerJump;

      routerJump = this.$router.resolve({
        path: "/parallelListPage",
        query: {
          url:
            "erp/website/pageQy.json?op=findPageMember\nerp/website/pageQy.json?op=getMemberByMemberId",
          id: -1,
          name: "组织成员",
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList6Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "recruitJobDetail",
        query: {
          recruitJobId: item.recruitJobId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList6Page() {
      this.$router.push({
        path: "/recruitJobList",
        id: -1,
      });
    },
    textList5Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getDemandByDemandId",
          pageViewId: item.demandId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList5Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=TALENT\nerp/website/pageQy.json?op=findPageProfessionDemand&businessTypeCode=COURSEDEMAND",
          id: -1,
        },
      });
    },
    textList4Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getDemandByDemandId",
          pageViewId: item.demandId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList4Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=TALENT\nerp/website/pageQy.json?op=findPageProfessionDemand&businessTypeCode=PROFESSIONDEMAND",
          id: -1,
        },
      });
    },
    textList3Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getTopicByTopicId",
          pageViewId: item.topicId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList3Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=NEWS\nerp/website/pageQy.json?op=findPageTopic&businessTypeCode=GROUPINFO",
          id: -1,
        },
      });
    },

    textList2Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getTopicByTopicId",
          pageViewId: item.topicId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList2Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=NEWS\nerp/website/pageQy.json?op=findPageTopic&businessTypeCode=POLICY",
          id: -1,
        },
      });
    },
    textList1Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getTopicByTopicId",
          pageViewId: item.topicId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList1Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=NEWS\nerp/website/pageQy.json?op=findPageTopic&businessTypeCode=TRADEINFO",
          id: -1,
        },
      });
    },
    textList0Txt(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getTopicByTopicId",
          pageViewId: item.topicId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    textList0Page() {
      this.$router.push({
        path: "/leftMenuListPage",
        query: {
          url:
            "erp/website/menuQy.json?op=findPortalMenuTree&parentItemCode=NEWS\nerp/website/pageQy.json?op=findPageTopic&businessTypeCode=NEWSREPORT",
          id: -1,
        },
      });
    },
    getTextList8() {
      topic_qy({ op: "findPageTechnologyServer", pageSize: 7 }).then((res) => {
        this.textList8 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList7() {
      topic_qy({ op: "findPageRemoteHelp", pageSize: 7 }).then((res) => {
        this.textList7 = [...res.result];
        this.$forceUpdate();
      });
    },
    getTextList6() {
      recruit_qy({ op: "findPageRecruitJob", pageSize: 7 }).then((res) => {
        this.textList6 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList5() {
      demand_qy({ op: "findPageCourseDemand", pageSize: 7 }).then((res) => {
        this.textList5 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList4() {
      demand_qy({ op: "findPageProfessionDemand", pageSize: 7 }).then((res) => {
        this.textList4 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList3() {
      topic_qy({ op: "findPageGroupInfo", pageSize: 7 }).then((res) => {
        this.textList3 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList2() {
      topic_qy({ op: "findPagePolicy", pageSize: 7 }).then((res) => {
        this.textList2 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList1() {
      topic_qy({ op: "findPageTradeInfo", pageSize: 7 }).then((res) => {
        this.textList1 = res.result;
        this.$forceUpdate();
      });
    },
    getTextList0() {
      topic_qy({ op: "findPageNewsReport", pageSize: 7 }).then((res) => {
        this.textList0 = [...res.result];
        this.$forceUpdate();
      });
    },

    openNoticeItem(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          url: "erp/website/pageQy.json?op=getNewsByNewsId",
          pageViewId: item.pageViewId,
          id: -1,
        },
      });

      window.open(routerJump.href, "_blank");
    },
    openNotice() {
      let routerJump;

      routerJump = this.$router.resolve({
        path: "/parallelListPage",
        query: {
          url:
            "erp/website/pageQy.json?op=findPageNotice\nerp/website/pageQy.json?op=getNewsByNewsId",
          id: -1,
          name: "通知公告",
        },
      });
      window.open(routerJump.href, "_blank");
    },
    getResource_qy() {
      resource_qy({
        op: "findPageResource",
        pageNo: 1,
        pageSize: 8,
        resourceStyles: "1",
      }).then((res) => {
        this.resource1 = res.result;
        this.resource1.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.resourceContent;
          res.resourceContent = objE.innerText;
        });
      });
    },
    getResource_qy2() {
      videoResourceQy({
        op: "findPageVideoResource",
        pageNo: 1,
        pageSize: 3,
      }).then((res) => {
        this.resource2 = res.result;
        this.resource2.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.resourceContent;
          res.resourceContent = objE.innerText;
        });
      });
    },
    leave() {
      this.enter = false;
    },
    enters() {
      this.enter = true;
    },
    styleLeftSetInt() {
      clearInterval(window.styleLeft);
      window.styleLeft = setInterval(() => {
        if (this.enter) {
          return;
        }
        this.left = this.left - 1;
        if (this.left == (0 - this.styleList.length * 104) / 2) {
          this.left = 0;
        }
        this.$forceUpdate();
      }, 20);
    },
    getStyleList() {
      organ_qy({ op: "findPageOrgan" }).then((res) => {
        this.styleList = [...res.result];
        if (this.styleList.length > 3) {
          this.styleList = [...this.styleList, ...this.styleList];
          this.mouseleave();
        }
      });
    },
    handleSelect() {},
    getPicture() {
      CarouselPictureQy({ op: "findCarouselPicture" }).then((res) => {
        res.map((res) => {
          if (res.url.indexOf("www") == 0) {
            res.url = "http://" + res.url;
          }
        });
        this.pictureList = res;
      });
    },
    getNoticeQy() {
      noticeQy({
        op: "findPageNotice",
        pageSize: 20,
        pageNo: 1,
      }).then((res) => {
        this.noticeTotalCount = res.totalCount;
        this.noticeListRoll = [...res.result];
        this.noticeList = this.noticeListRoll.slice(0, 6);
        if (this.noticeListRoll.length > 6) {
          this.roll();
        }
      });
    },
    roll() {
      let index = 6;
      clearInterval(window.noticeSetInt);
      window.noticeSetInt = setInterval(() => {
        this.noticeRoll = true;
        setTimeout(() => {
          this.noticeList.shift();
          this.noticeRoll = false;
          if (!this.noticeListRoll[index]) {
            index = 0;
          }
          this.noticeList.push(this.noticeListRoll[index]);
          index++;
        }, 1000);
      }, 3000);
    },
  },
};
</script>

<style lang="less" scoped>
.noticeRoll {
  margin-top: -53px;
}
.noticeRoll {
  transition: all 1s;
}
.content {
  margin: 0 auto;
  .box {
    box-shadow: 0 0 5px 2px #ddd;
    background: #fff;
    height: 400px;
    border: 1px solid #ddd;
    border-radius: 5px;
    position: relative;
    .move {
      a {
        color: #333;
      }
      a:hover {
        color: #1890ff;
      }
      line-height: 30px;
      top: 10px;
      padding-right: 20px;
      position: absolute;
      right: 0;
      font-size: 14px;
    }
    .title {
      line-height: 50px;

      padding: 0 20px;
      font-weight: 600;
      color: #666;
      background: rgb(235, 235, 235);
    }
    .list {
      padding: 10px;
      li {
        padding: 15px 10px;
        border-bottom: 1px solid #ddd;
      }
      .radiusTop {
        border-radius: 5px 5px 0 0;
      }
      .radiusBottom {
        border-radius: 0 0 5px 5px;
      }
      .radius {
        border-radius: 5px 5px 5px 5px;
      }
    }
  }
  .titleH2 {
    line-height: 50px;
    text-align: center;
    position: relative;
    .titleH2Move {
      position: absolute;
      bottom: 10px;
      right: 0;
      font-size: 14px;
      font-weight: 100;
      line-height: 20px;
    }
  }
  .style {
    height: 250px;
    background: url("~@/assets/img/bg.jpg") no-repeat 100% 100%;
    padding: 50px 0;
    overflow: hidden;
    position: relative;
    margin-bottom: 20px;
    .styleList {
      position: absolute;
      top: 50px;
      left: 0;
    }
    .styleBox {
      height: 150px;
      width: 300px;
      background: #fff;
      display: inline-block;
      margin: 0 20px;
      position: relative;
      padding-left: 100px;
      .img {
        height: 80px;
        width: 80px;
        position: absolute;
        top: 30px;
        left: 10px;
      }
      .introduce {
        height: 80px;
        overflow: hidden;
        font-size: 14px;
        padding: 0 10px;
      }
      .organName {
        line-height: 60px;
        font-size: 20px;
        font-weight: 600;
        padding: 0 10px;
      }
    }
  }
  .resourceBox {
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 0 5px 2px #ddd;
    height: 426px;
    padding: 10px;
    font-size: 14px;
    background: #fff;
    .resource0 {
      height: 100px;
      padding-left: 100px;
      position: relative;
      .resourceTitle {
        font-weight: 600;
        line-height: 30px;
        padding: 0 10px;
      }
      .resourceContent {
        padding: 0 10px;
        height: 70px;
        line-height: 24px;
        overflow: hidden;
      }
      .img {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .heades {
      font-size: 25px;
      line-height: 48px;
      height: 48px;
      position: relative;

      .titles {
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 20px;
        color: #fff;
        font-size: 16px;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
      }
      .headesMove {
        cursor: pointer;
        float: right;
        font-size: 14px;
        line-height: 36px;
        position: absolute;
        top: 6px;
        right: 15px;
        color: #666;
        &:hover {
          color: #1890ff;
        }
      }
    }
    .resourceTitle1 {
      display: inline-block;
      line-height: 30px;
    }
    .createDate {
      float: right;
      line-height: 30px;
    }
  }
  .pointer {
    cursor: pointer;
    color: #666;
    i {
      padding-right: 5px;
      color: #999;
      font-size: 18px;
    }
    position: relative;
  }
  .pointer:hover {
    color: #1890ff;
    i {
      color: #1890ff;
    }
  }
}
.carouselItemText {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
}
/deep/.el-carousel__button {
  height: 8px;
  width: 8px;
  border-radius: 50%;
}
/deep/.el-carousel__indicators--horizontal {
  left: auto;
  right: 0;
}
.benner {
  position: relative;
  overflow: hidden;
  .bennerList {
    position: absolute;
    white-space: nowrap;
  }

  height: 140px;
  li {
    display: inline-block;
    margin-right: 10px;
  }
  margin-bottom: 20px;
}
.typeButBox {
  padding-top: 100px;
  .typeBut {
    padding-left: 20px;
    margin-bottom: 50px;
    position: relative;
    span {
      position: absolute;
      top: 30px;
      left: 120px;
      color: #fff;
    }
  }
}
.newsBox {
  border-right: 1px #ddd dashed;
  padding-right: 15px;
  margin-bottom: 25px;
  position: relative;
  .newHead {
    color: #fff;
    font-size: 16px;
    width: 225px;
    height: 44px;
    line-height: 44px;
    background: url("~@/assets/img/newHead.png") no-repeat;
    margin: 0 auto;
    text-align: center;
    .mome {
      position: absolute;
      right: 5px;
      font-size: 14px;
      color: #666;
    }
    .mome:hover {
      color: #1890ff;
    }
  }
  .newList {
    font-size: 14px;
    line-height: 35px;
    height: 260px;
    border-bottom: 1px solid #ddd;
    .topicTitle {
      width: 294px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>